export default "__VITE_ASSET__8f5060af__"